module.exports = __webpack_public_path__ + "static/media/Record Crackle.4d5ce1be.ogg";